export const isoLangCodes = {
	// ISO 639-1 https://id.loc.gov/vocabulary/iso639-1.html
	fa: 'fa',
	fa_IR: 'fa-IR',
	en: 'en',
	en_US: 'en-US',
};